import React from 'react'
import '../components-css/privacy-policy.scss'

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-container">
            <h1>Anti Spam Policy</h1>
            <div className="content">
                <p>ANTI-SPAM POLICY</p>

                Last Updated: April 22, 2026 <br /> <br />

                <strong>OMKA TECH LLP</strong>, operating under the brand names OMKA TECH, omkatech.com, and omkatechnologies.com (collectively, "the Company", "we", "our", or "us"), maintains a strict zero-tolerance policy against spam and unsolicited bulk email. This Anti-Spam Policy outlines our commitment to responsible email communication and applies to all domains owned and operated by the Company, including but not limited to omkatech.com and omkatechnologies.com. <br /> <br />

                <strong>1. SCOPE OF THIS POLICY</strong> <br /> <br />

                This policy governs the use of email communication involving any domain owned by OMKA TECH LLP. It applies to: <br />

                a) All employees, contractors, interns, and authorized representatives of the Company. <br />
                b) All third-party agents, affiliates, resellers, marketing partners, and sub-contractors acting on behalf of the Company. <br />
                c) All automated systems, tools, software, and services contracted or operated by the Company for communication purposes. <br />
                d) Any individual or entity granted access to email accounts on any Company-owned domain. <br /><br />

                <strong>2. PROHIBITION ON UNSOLICITED BULK EMAIL</strong> <br /> <br />

                The Company strictly prohibits the advertising, promotion, or mention of the websites omkatech.com, omkatechnologies.com, and any other Company-owned domain through: <br />

                a) Unsolicited commercial email (UCE) sent to recipients who have not given prior express consent. <br />
                b) Unsolicited bulk email (UBE) sent en masse to purchased, rented, scraped, or otherwise non-opt-in recipient lists. <br />
                c) Email communication sent through open relays, compromised servers, or unauthorized sending infrastructure. <br />
                d) Email messages that use false, misleading, or forged header information, sender addresses, or subject lines. <br />
                e) Email messages that fail to identify the sender, the sender's organization, or the purpose of the communication. <br />
                f) Email messages that do not provide a clear and functional method to opt out of future communication. <br /><br />

                <strong>3. PERMITTED EMAIL COMMUNICATION</strong> <br />

                The Company engages in the following forms of permitted email communication: <br />

                a) Direct correspondence with existing clients, vendors, partners, and suppliers with whom an active business relationship exists. <br />
                b) Replies to inbound inquiries received through our website contact forms, email, phone, or other communication channels initiated by the recipient. <br />
                c) Business-to-business (B2B) outreach to professionally researched and individually verified contacts, where each email is personalized, identifies the sender and the Company, states the purpose, and provides an opt-out option. <br />
                d) Transactional emails related to service delivery, project updates, invoices, contracts, and support communication. <br />
                e) Opt-in email communication where the recipient has explicitly consented to receive communication from the Company. <br /><br />

                <strong>4. PROHIBITED PRACTICES BY EMPLOYEES AND AGENTS</strong> <br />

                Employees, contractors, and any third parties acting on behalf of OMKA TECH LLP are expressly prohibited from: <br />

                a) Purchasing, renting, harvesting, or using third-party email lists without verified opt-in consent. <br />
                b) Using address-harvesting software or automated scraping tools to collect email addresses. <br />
                c) Sending bulk email from Company domains without prior written authorization from Company management. <br />
                d) Impersonating the Company, its employees, or its clients in any email communication. <br />
                e) Sending email that violates the CAN-SPAM Act (United States), GDPR (European Union), CASL (Canada), the Information Technology Act (India), or any other applicable anti-spam legislation in the recipient's jurisdiction. <br /> <br />

                <strong>5. AUTHENTICATION AND SECURITY</strong> <br />

                All outbound email from Company-owned domains is transmitted through authenticated enterprise email infrastructure (Google Workspace) with the following authentication mechanisms enabled: <br />

                a) Sender Policy Framework (SPF) records to authorize sending servers. <br />
                b) DomainKeys Identified Mail (DKIM) signing to verify message integrity. <br />
                c) Domain-based Message Authentication, Reporting and Conformance (DMARC) policy for handling unauthorized senders. <br /> <br />

                The Company does not authorize, operate, or permit the use of open relays, shared IP pools, or unauthenticated sending infrastructure for any Company-related email communication. <br /> <br />

                <strong>6. CONSEQUENCES OF VIOLATION</strong> <br />

                Any employee, contractor, agent, affiliate, or third party found violating this Anti-Spam Policy is subject to: <br />

                a) Immediate termination of employment, contract, or business engagement with the Company. <br />
                b) Revocation of access to all Company-owned email accounts and systems. <br />
                c) Legal action, including claims for damages caused to the Company's reputation and domain standing. <br />
                d) Reporting to relevant authorities, blacklist operators, and email service providers where applicable. <br /> <br />

                <strong>7. REPORTING SPAM OR POLICY VIOLATIONS</strong> <br />

                If you have received an email from any Company-owned domain that you believe violates this Anti-Spam Policy, or if you believe our domain is being used in an unauthorized or fraudulent manner by a third party, please report the incident to us immediately. <br />

                Email: abuse@omkatech.com <br />
                Alternate: deepak@omkatechnologies.com <br />

                Please include the full message headers and body of the suspected email when reporting. We investigate all abuse reports within five (5) business days and take appropriate action, including but not limited to disabling compromised accounts, terminating responsible personnel, and cooperating with law enforcement and blacklist operators. <br /> <br />

                <strong>8. COMPLIANCE WITH BLACKLIST AND REPUTATION AUTHORITIES</strong> <br />

                OMKA TECH LLP fully cooperates with email blacklist operators, anti-spam authorities, internet service providers, and email reputation services. We maintain proactive monitoring of our domain reputation and take immediate corrective action upon any report of abuse or listing. <br /> <br />

                <strong>9. POLICY UPDATES</strong> <br />

                This Anti-Spam Policy may be updated from time to time to reflect changes in legal requirements, best practices, or Company operations. The current version of this policy will always be available at https://omkatech.com/anti-spam-policy. Continued use of Company email services by employees, contractors, and partners constitutes acceptance of the most recent version of this policy. <br /> <br />

                <strong>10. CONTACT INFORMATION</strong> <br />

                For questions, clarifications, or concerns regarding this Anti-Spam Policy, please contact: <br /> <br />

                OMKA TECH LLP <br />
                H-17, JAV Tower, Sector 63 <br />
                Noida, Uttar Pradesh 201307 <br />
                India <br /> <br />

                Phone: +91 97175 11913 <br />
                Email: deepak@omkatechnologies.com <br />
                Website: https://omkatech.com <br />
            </div>
        </div>
    )
}

export default PrivacyPolicy